<template>
  <div class="creditos-especial">
		<div class="position-relative">
			<div class="row justify-content-center m-0 list-credits pt-5 pb-5">
				<div class="col-md-8 col-12 col-lg-8">
					<div class="credits text-center">					
						<h3>{{ $t('creditos.creditos_resenia') }}</h3>
						
							<div class="mt-3">
								<div class="text-center">
									<span class="title">{{ $t('creditos.equipo_foco') }}:</span>
									<div class="mb-3 nombre">
										{{ $t('creditos.equipo_lista') }}
									</div>
								</div>
								<div class="text-center">
									<span class="title">{{ $t('creditos.editora') }}:</span>
									<div class="mb-3 nombre">
										{{ $t('creditos.editora_name') }}
									</div>
								</div>
								<div class="text-center">
									<span class="title">{{ $t('creditos.edicion_video') }}:</span>
									<div class="mb-3 nombre">
										{{ $t('creditos.edicion_name') }}
									</div>
								</div>
								<div class="text-center">
									<span class="title">{{ $t('creditos.desarrollo_label') }}:</span>
									<div class="mb-3 nombre">
										{{ $t('creditos.desarrollo_name') }}
									</div>
								</div>
								
							</div>					
					</div>
				</div>
				<div class="col-md-6 col-12 col-lg-6">
					<div class="creditos-support">
						<span>{{ $t('creditos.creditos_support') }}</span>
					</div>
				</div>
			</div>
	
		</div>
	</div>
</template>

<script>



export default {
  name: 'Creditos',

}
</script>

